import { ClipLoader } from "react-spinners";

const LoadingSpinner = ({
  size,
  color,
  loading,
  borderWidth
}) => {
  return (
    <ClipLoader
      size={size || 20}
      color={color || "#ffffff"}
      loading={loading || false}
      cssOverride={{ borderWidth: borderWidth || "3px" }}
    />
  );
};

export default LoadingSpinner;
